import { useState } from "react";
import { Dropdown } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { NavLink } from "react-router-dom";
import flag from "../../images/Flag.png";
import { setformmodal, setformstatus, setauthstatus } from "../../redux/formslice";
import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import { useSelector } from "react-redux";
import { FaUser } from "react-icons/fa";
import profileimg from "../../images/Profile.png";
import orderimg from "../../images/order.png"; // Replace with actual path
import { setcartlistdata } from "../../redux/cartslice";
import whistlistimage from "../../images/Stroke 1.png";
import trackorder from "../../images/Location.png";
import complaints from "../../images/Info Square.png";
import logout from "../../images/Logout.png";
import { useDispatch } from "react-redux";
import Cookies from "js-cookie";
const dropdownItems = [
    { to: "/myaccount", img: profileimg, label: "My Profile" },
    { to: "/my-orders", img: orderimg, label: "My Order" },
    { to: "/my-wishlist", img: whistlistimage, label: "Wishlist" },
    { to: "/track-your-order", img: trackorder, label: "Track Order" },
    { to: "/address", img: trackorder, label: "Address" },
    { to: "/complaints", img: complaints, label: "Complaints" },
];

export default function Pagedropdown({ logindata }) {
    const closeDropdown = () => setIsDropdownOpen(false);
    const toggleUserDropdown = () => setIsDropdownOpen(!isDropdownOpen);
    const logoutclick = () => {
        Cookies.remove("jwt_token");
        Cookies.remove("cart_ip_address");
        dispatch(setauthstatus(false));
        dispatch(setcartlistdata([]));

    };
    // const [selected, setSelected] = useState(options[0]);
    const [isOpen, setIsOpen] = useState(false);

    const currentcountry = useSelector((state) => state.globalslice.currentcountry);

    const dispatch = useDispatch();
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);

    return (
        <Dropdown
            className="header-middle-rightsub countrydropdown"
            show={isOpen}
            onMouseEnter={() => setIsOpen(true)}  // Open on hover
            onMouseLeave={() => setIsOpen(false)} // Close on hover out
        >

            <Dropdown.Toggle className="cursor-pointer headermain flex usermain items-center">
                <FaUser size={16} />
                <span className="ps-2 header-middle-right-title username">{logindata.first_name}</span>
            </Dropdown.Toggle>

            <Dropdown.Menu className="custom-dropdown-menu">
                {dropdownItems.length > 0 && dropdownItems.map((item, index) => (
                    <Dropdown.Item
                        key={item.name}
                    >
                        <NavLink
                            key={index}
                            className="userdropdown text-decoration-none"
                            to={item.to}
                            onClick={closeDropdown}
                        >
                            <img src={item.img} alt={item.label} />
                            <div className="dropdownpages">{item.label}</div>
                        </NavLink>
                    </Dropdown.Item>
                ))}
                <Dropdown.Item onClick={logoutclick}>
                    <NavLink
                        className="userdropdown text-decoration-none"
                        onClick={closeDropdown}
                    >
                        <img src={logout} alt="logout" />
                        <div className="dropdownpages">Logout</div>
                    </NavLink>

                </Dropdown.Item>
            </Dropdown.Menu>
        </Dropdown>
    );
}
